module.exports = __webpack_public_path__ + "assets/imgs/logos/fb.470fbb85d09b956fd1d5855783b7cbdb.svg";